import type { UseQueryOptions, UseQueryReturnType } from '@tanstack/vue-query'
import { useQuery } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../query-ids'
import type { GetReturn } from '~~/src/types/utils'
import { getAdStatus } from '~~/src/api/ads'

export const useAdsStatusQuery = (
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getAdStatus>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getAdStatus>, Error> => {
  return useQuery({
    queryKey: [TanStackQueryIds.ADS_STATUS] as const,
    queryFn: async () => {
      return await getAdStatus()
    },
    staleTime: 300_000, // 5min
    ...options,
  })
}
